import {
  ActionIcon,
  Box,
  Button,
  Card,
  Center,
  Container,
  Grid,
  Group,
  Loader,
  Radio,
  Select,
  SimpleGrid,
  Text,
  TextInput,
} from "@mantine/core";

import { IconChevronLeft } from "@tabler/icons-react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useStyles } from "./style";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import { DateInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useEffect } from "react";
import GreenCheck from "../../components/Svgs/GreenCheck";
import swal from "sweetalert";

import {
  addAchpayment,
  addInvoicepayment,
  addInvoicepaymentthroughCashAndCheque,
  addNewInvoicepayment,
} from "../../services/payment";
import { decrypt } from "../../utils";
import { frontendURL, https, stripe_publishable_key } from "../../http";
import PaymentForm from "./PaymentForm";
import { getSingleBillingInvoices } from "../../services/billinginvoice";

const stripePromise = loadStripe(
  stripe_publishable_key
);

const InvoicePayment = () => {
  const [value, setValue] = useState("manual");
  const [paymentoption, setPaymentOption] = useState(" ");
  const [achLink, setAchLink] = useState(true);
  const [link, setLink] = useState(null);

  console.log("value", value);

  const navigate = useNavigate();
  const location = useLocation();
  const { profile } = useSelector((state) => state.profile);
  const [amount, setAmount] = useState(null);
  const [invoiceid, setInvoiceId] = useState(null);

  const { classes } = useStyles();

  const [connectingCard, setConnectingCard] = useState(false);
  const [options, setOption] = useState(null);
  const [loading, setLoading] = useState(false);
  const [paymentIntentData, setPaymentIntentData] = useState(null);
  const [invoicepaid, setInvoicePaid] = useState(false);

  // console.log("paymentIntentData", paymentIntentData);

  // console.log("invoicepaid", invoicepaid);
  // console.log("paymentoption", paymentoption);

  const handlePayment = async (myamount, invoiceId) => {
    console.log("here amount", myamount);

    if (paymentoption === "card" || paymentoption === "ach") {
      const payload = {
        amount: Number(myamount),
        invoiceId,
      };

      try {
        const res = await addNewInvoicepayment(payload);
        console.log("res", res);

        const client_secret = res?.data?.paymentIntent?.client_secret;

        setPaymentIntentData(client_secret);
      } catch (error) {
        console.error("Error adding new invoice payment:", error);
      }
    }
  };

  const handlePaymentSuccess = (paymentIntent) => {
    console.log("Payment succeeded:", paymentIntent);
  };

  const handlePaymentChange = async (value) => {
    setPaymentOption(value);
    if (value !== "") {
      form.setFieldValue("paymentoption", value);
    }

    // if (paymentoption === "ach") {
    //   console.log("in the ach");

    //   await AchOpen();
    // } else {
    //   form.setFieldValue("paymentoption", "");
    // }
  };

  const form = useForm({
    initialValues: {
      nameCard: "",
      cardNumber: "",
      CVV: "",
      cardMonth: null,
      cardYear: null,
      name: "",
      email: "",
      phone: "",
      address: "",
      ChequeNo: "",
      BankName: "",
      dateofIssue: "",
      drawerName: "",
    },
    // validate: {
    //   nameCard: (value) => (value ? null : "Please add card name"),
    //   cardNumber: (value) =>
    //     value && value?.length <= 16 ? null : "Please add a valid card number",
    //   cardExp: (value) => (value ? null : "Select expiry date"),
    //   CVV: (value) => {
    //     const isValidLength =
    //       value && (value?.length === 3 || value?.length === 4);
    //     return isValidLength ? null : "Please add a valid number";
    //   },
    // },

    validate: (values) => {
      const errors = {};

      if (paymentoption !== "cash" && paymentoption !== "cheque") {
        if (!values.nameCard) {
          errors.nameCard = "Please add card name";
        }

        if (!values.cardNumber || values.cardNumber.length !== 16) {
          errors.cardNumber = "Please add a valid card number";
        }

        // if (!values.cardExp) {
        //   errors.cardExp = "Select expiry date";
        // }

        const isValidLengthMonth = values && values.cardMonth.length === 2;
        // console.log('isValidLengthMonth',isValidLengthMonth);

        if (!values.cardMonth || !isValidLengthMonth) {
          errors.cardMonth = "Please add a valid month";
        }

        const isValidLengthYear = values && values.cardYear.length === 2;

        if (!values.cardYear || !isValidLengthYear) {
          errors.cardYear = "Please add a valid Year";
        }
        // cardMonth: (value) => {
        //   const isValidLength = value && value.length === 2;
        //   return isValidLength ? null : "Please add a valid month";
        // },
        // cardYear: (value) => {
        //   const isValidLength = value && value.length === 2;
        //   return isValidLength ? null : "Please add a valid year";
        // },

        const isValidCVVLength =
          values.CVV && (values.CVV.length === 3 || values.CVV.length === 4);
        if (!values.CVV || !isValidCVVLength) {
          errors.CVV = "Please add a valid number";
        }
      }

      if (paymentoption === "cheque") {
        if (!values.name) {
          errors.name = "Please provide a name";
        }
        if (!values.email) {
          errors.email = "Please provide a email";
        }
        if (!values.phone) {
          errors.phone = "Please provide a phone";
        }
        if (!values.address) {
          errors.address = "Please provide a address";
        }

        if (!values.ChequeNo) {
          errors.ChequeNo = "Please provide a cheque number";
        }
        if (!values.BankName) {
          errors.BankName = "Please provide bank name";
        }
        // if (!values.dateofIssue) {
        //   errors.dateofIssue = "Please provide date of issue";
        // }
        // if (!values.drawerName) {
        //   errors.drawerName = "Please provide drawer Name";
        // }
      }

      if (paymentoption === "cash") {
        if (!values.name) {
          errors.name = "Please provide a name";
        }
        if (!values.email) {
          errors.email = "Please provide a email";
        }
        if (!values.phone) {
          errors.phone = "Please provide a phone";
        }
        if (!values.address) {
          errors.address = "Please provide a address";
        }
      }

      return errors;
    },
  });

 console.log('paymentoption',paymentoption);

 console.log('form',form.errors);
 

// console.log('options',options);

useEffect(()=>{
  const urlParams = new URLSearchParams(location.search);
let paymentToken = urlParams.get("paymentToken");
  paymentToken = paymentToken?.replaceAll(" ", "+");  
  if (paymentToken) {
    try {
      const decryptedtoken = decrypt(paymentToken);
      setOption(decryptedtoken.paymentoptios);
      if (decryptedtoken.paymentoptios) {
        if (decryptedtoken.paymentoptios.debitCredit === true) {
          setPaymentOption("card");
        } else {
          const firstTrueOption = Object.entries(decryptedtoken.paymentoptios)?.find(
            ([_, value]) => value === true
          )?.[0] || '';
          setPaymentOption(firstTrueOption);
        }
      }
      

  
      


    
    } catch (err) {
      console.error("Failed to decrypt paymentToken:", err);
    }
  } else {
    console.error("No paymentToken found in query params");
  }
},[])

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);

    let paymentToken = urlParams.get("paymentToken");
    paymentToken = paymentToken?.replaceAll(" ", "+");

    console.log("paymentToken", paymentToken);

    if (paymentToken) {
      try {
        const decryptedtoken = decrypt(paymentToken);

        console.log("decryptedtoken", decryptedtoken);

        setAmount(decryptedtoken.amount);
        setInvoiceId(decryptedtoken.invoiceId);
        // setOption(decryptedtoken.paymentoptios);
        // if (decryptedtoken.paymentoptios) {
        //   if (decryptedtoken.paymentoptios.debitCredit === true) {
        //     setPaymentOption("card");
        //   } else {
        //     const firstTrueOption = Object.entries(decryptedtoken.paymentoptios)?.find(
        //       ([_, value]) => value === true
        //     )?.[0] || '';
        //     setPaymentOption(firstTrueOption);
        //   }
        // }
        

        const fetchInvoiceDetails = async () => {
          try {
            let payload = {
              query: decryptedtoken.invoiceId,
            };

            const res = await getSingleBillingInvoices(payload);

            // console.log('res', res);

            if (res && res.status === 200) {
              if (
                res?.data &&
                res?.data?.billingSingleinvoice?.status === "Paid"
              ) {
                setInvoicePaid(true);
              }
            } else {
              console.error("Failed to fetch invoice data or invalid response");
            }
          } catch (err) {
            console.error("Error fetching invoice details:", err);
          }
        };

        fetchInvoiceDetails();

        


        if (paymentoption === "card" || paymentoption === "ach") {
          handlePayment(decryptedtoken.amount, decryptedtoken.invoiceId);
        }
      } catch (err) {
        console.error("Failed to decrypt paymentToken:", err);
      }
    } else {
      console.error("No paymentToken found in query params");
    }
  }, [location, paymentoption]);






  useEffect(() => {
    if (form.getInputProps("cardNumber")?.value?.length > 16) {
      form.setFieldValue(
        "cardNumber",
        form.getInputProps("cardNumber")?.value?.slice(0, 16)
      );
    }
  }, [form.getInputProps("cardNumber")?.value]);

  useEffect(() => {
    if (form.getInputProps("CVV")?.value?.length > 4) {
      form.setFieldValue("CVV", form.getInputProps("CVV")?.value?.slice(0, 4));
    }
  }, [form.getInputProps("CVV")?.value]);

  // useEffect(() => {
  //   if (form.getInputProps("cardMonth")?.value?.length > 2) {
  //     form.setFieldValue(
  //       "cardMonth",
  //       form.getInputProps("cardMonth")?.value?.slice(0, 2)
  //     );
  //   }
  // }, [form.getInputProps("cardMonth")]);

  // useEffect(() => {
  //   pageInfoAnalytics("Payment Info Page Viewed", "Payment Info Page");
  // }, []);

  const AchOpen = async () => {
    setLoading(true);
    setPaymentOption("ach");
    try {
      let payload = {
        amount,
        invoiceId: invoiceid,
      };

      let response = await addAchpayment(payload);

      const url = response?.data?.session?.url;
      setLink(url);
      setLoading(false);
      window.location.href = url;
    } catch (error) {
      console.log("error", error);
    }
  };

  const onFinish = async (values) => {
    console.log("values", values);
    const { cardMonth, cardYear } = values;
    let obj = {
      ...values,
      amount,
      invoiceId: invoiceid,
      cardExp: `${cardMonth}/${cardYear}`,
      // userId: profile?.user.id,
      paymentoption,
      // email: profile?.user?.email,
      // businessId: profile?.business?.id
    };

    console.log("obj", obj);

    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Proceed"],
    });
    if (willDelete) {
      setConnectingCard(true);

      let response = null;

      if (paymentoption === "cash" || paymentoption === "cheque") {
        // console.log('in the cash and cheque');
        // let response = await https().get(baseURL);

        response = await addInvoicepaymentthroughCashAndCheque(obj);

        
        if (response.status === 200) {
          swal({
            title: `Payment successfully`,
            text: "Payment successfully",
            dangerMode: false,
            icon: "success",
          });

           await onBack();
        } else {
          swal({
            title: `Payment not proceed`,
            text: "Payment not proceed successfully",
            dangerMode: true,
          });
        }

        // const url = "http://18.217.220.75:3000/";
        // const url = "https://staging.ogiso.io";
        // const url =frontendURL;

        // window.location.href = url;
      } else {
        response = await addInvoicepayment(obj);

        console.log("response", response);

        // const url = response?.data?.session?.url;

        // window.location.href = url;

        if (response.status === 200) {
          swal({
            title: `Payment successfully`,
            text: "Payment successfully",
            dangerMode: false,
            icon: "success",
          });

          // await onBack();
        } else {
          swal({
            title: `Payment not proceed`,
            text: "Payment not proceed successfully",
            dangerMode: true,
          });
        }
      }
      // addInvoicepayment(obj, (error, data) => {
      //   if (!error) {
      //     setConnectingCard(false);
      //     // if (newConnect === "true") return navigate("/home/settings");
      //     return navigate("/home/billing-invoices");
      //     // getAllConnected();
      //   } else {
      //     setConnectingCard(false);
      //   }
      // });
    } else {
      return navigate("/home/invoices");
    }
  };
  const onBack = () => {
    const url = frontendURL;

    window.location.href = url;
  };




  return (
    <Box className={[classes.paymentPage, "payment-page"]}>
      <Group className={classes.back}>
        <ActionIcon
          size={"xl"}
          radius={"xl"}
          onClick={onBack}
          variant="outline"
        >
          <IconChevronLeft />
        </ActionIcon>
        <Text>Back</Text>
      </Group>

      {value === "manual" &&
        (!invoicepaid ? (
          <Container size={"md"} className={classes.centered}>
            <Box className={classes.logo}>
              <img width={"20%"} src="assets/images/logo2.png" alt="" />
            </Box>
            <Text className={classes.title}>Add Invoice Payment</Text>
            <Text className={classes.subTitle}>
              Welcome back! Please enter your details.
            </Text>
            <Card shadow="sm" className={classes.card}>
              <form onSubmit={form.onSubmit((values) => onFinish(values))}>
                <Box>
                  {/* <Text
                    style={{ marginBottom: "10px", textAlign: "left" }}
                    ff={"Inter"}
                    fz={20}
                    fw={700}
                    color="#262626"
                  >
                    Select Payment Type
                  </Text> */}
                  <Group>
                    {options?.debitCredit !== false &&
                      options?.ach !==false && (
                          <Text
                            className={classes.method}
                            onClick={() => handlePaymentChange("card")}
                            style={{ cursor: "pointer", userSelect: "none" }}
                          >
                            Credit/Debit Card/Ach{" "}
                            {paymentoption === "card" && <GreenCheck />}
                          </Text>
                        )}

                    {options?.debitCredit !== false &&
                      options?.ach !== true && (
                        <Text
                          className={classes.method}
                          onClick={() => handlePaymentChange("card")}
                          style={{ cursor: "pointer", userSelect: "none" }}
                        >
                          Credit/Debit Card{" "}
                          {paymentoption === "card" && <GreenCheck />}
                        </Text>
                      )}

                    {options?.ach !== false &&
                      options?.debitCredit !== true && (
                        <Text
                          className={classes.method}
                          // onClick={() => AchOpen()}
                          onClick={() => handlePaymentChange("ach")}
                          style={{ cursor: "pointer", userSelect: "none" }}
                        >
                          ACH {paymentoption === "ach" && <GreenCheck />}
                        </Text>
                      )}

                    {options?.cash !== false && (
                      <Text
                        className={classes.method}
                        onClick={() => handlePaymentChange("cash")}
                        style={{ cursor: "pointer", userSelect: "none" }}
                      >
                        Cash {paymentoption === "cash" && <GreenCheck />}
                      </Text>
                    )}

                    {options?.cheque !== false && (
                      <Text
                        className={classes.method}
                        onClick={() => handlePaymentChange("cheque")}
                        style={{ cursor: "pointer", userSelect: "none" }}
                      >
                        Check {paymentoption === "cheque" && <GreenCheck />}
                      </Text>
                    )}
                  </Group>
                </Box>

                {loading ? (
                  <Center>
                    <Loader />
                  </Center>
                ) : (
                  <>
                    {paymentoption === "cash" ? (
                      <Box className={classes.inputs}>
                        <SimpleGrid cols={2} className={classes.m10}>
                          <TextInput
                            size="lg"
                            variant="filled"
                            label="Name *"
                            placeholder="Eg.abc"
                            {...form.getInputProps("name")}
                            className={[classes.myfont, classes.m10]}
                          />
                          <TextInput
                            size="lg"
                            variant="filled"
                            label="Email*"
                            placeholder="Eg.abc@gmail.com"
                            {...form.getInputProps("email")}
                            className={[classes.myfont, classes.m10]}
                          />
                        </SimpleGrid>
                        <SimpleGrid cols={2} className={classes.m10}>
                          <TextInput
                            size="lg"
                            variant="filled"
                            label="Phone *"
                            placeholder="Eg.+2363"
                            {...form.getInputProps("phone")}
                            className={[classes.myfont, classes.m10]}
                          />
                          <TextInput
                            size="lg"
                            variant="filled"
                            label="Address *"
                            placeholder="Eg.abc"
                            {...form.getInputProps("address")}
                            className={[classes.myfont, classes.m10]}
                          />
                        </SimpleGrid>
                        <TextInput
                          size="lg"
                          variant="filled"
                          label="Amount Paid"
                          disabled={true}
                          value={amount}
                          className={[classes.myfont, classes.m10]}
                        />
                      </Box>
                    ) : paymentoption === "cheque" ? (
                      <Box className={classes.inputs}>
                        <SimpleGrid cols={2} className={classes.m10}>
                          <TextInput
                            size="lg"
                            variant="filled"
                            label="Name *"
                            placeholder="Eg.abc"
                            {...form.getInputProps("name")}
                            className={[classes.myfont, classes.m10]}
                          />
                          <TextInput
                            size="lg"
                            variant="filled"
                            label="Email*"
                            placeholder="Eg.abc@gmail.com"
                            {...form.getInputProps("email")}
                            className={[classes.myfont, classes.m10]}
                          />
                        </SimpleGrid>
                        <SimpleGrid cols={2} className={classes.m10}>
                          <TextInput
                            size="lg"
                            variant="filled"
                            label="Phone *"
                            placeholder="Eg.+2363"
                            {...form.getInputProps("phone")}
                            className={[classes.myfont, classes.m10]}
                          />
                          <TextInput
                            size="lg"
                            variant="filled"
                            label="Address *"
                            placeholder="Eg.abc"
                            {...form.getInputProps("address")}
                            className={[classes.myfont, classes.m10]}
                          />
                        </SimpleGrid>

                        <SimpleGrid cols={2} className={classes.m10}>
                          <TextInput
                            size="lg"
                            variant="filled"
                            label="Cheque Number*"
                            placeholder="Eg.abc"
                            {...form.getInputProps("ChequeNo")}
                            className={[classes.myfont, classes.m10]}
                          />
                          <TextInput
                            size="lg"
                            variant="filled"
                            label="Bank Name*"
                            placeholder="Eg.abc"
                            {...form.getInputProps("BankName")}
                            className={[classes.myfont, classes.m10]}
                          />
                        </SimpleGrid>

                        {/* <SimpleGrid cols={2} className={classes.m10}>
                          <Grid align="flex-end">
                            <Grid.Col xs={12} sm={12} md={6}>
                              <Grid>
                                <Grid.Col
                                  className={classes.marginTop}
                                  xs={12}
                                  sm={12}
                                  md={6}
                                >
                                  <TextInput
                                    size="lg"
                                    type="number"
                                    variant="filled"
                                    placeholder="MM"
                                    className={classes.myfont}
                                    {...form.getInputProps("cardMonth")}
                                  />
                                </Grid.Col>
                                <Grid.Col xs={12} sm={12} md={6}>
                                  <TextInput
                                    size="lg"
                                    type="number"
                                    variant="filled"
                                    placeholder="YY"
                                    className={classes.myfont}
                                    {...form.getInputProps("cardYear")}
                                  />
                                </Grid.Col>
                              </Grid>
                            </Grid.Col>
                            <Grid.Col xs={12} sm={12} md={6}>
                              <TextInput
                                size="lg"
                                label="CVV"
                                type="number"
                                variant="filled"
                                placeholder="Eg.***"
                                className={classes.myfont}
                                {...form.getInputProps("CVV")}
                              />
                            </Grid.Col>
                          </Grid>
                        </SimpleGrid>

                        <TextInput
                          size="lg"
                          variant="filled"
                          label="Drawer Name *"
                          placeholder="Eg.abc"
                          {...form.getInputProps("drawerName")}
                          className={[classes.myfont, classes.m10]}
                        /> */}
                        <TextInput
                          size="lg"
                          variant="filled"
                          label="Amount Paid"
                          disabled={true}
                          value={amount}
                          className={[classes.myfont, classes.m10]}
                        />
                      </Box>
                    ) : paymentoption === "ach" ? (
                      <Box className={classes.inputs}>
                        {paymentIntentData !== null ? (
                          <Elements
                            stripe={stripePromise}
                            options={{ clientSecret: paymentIntentData }}
                          >
                            <PaymentForm
                              paymentIntentClientSecret={paymentIntentData}
                              onPaymentSuccess={handlePaymentSuccess}
                              paymentoption={paymentoption}
                            />
                          </Elements>
                        ) : <Center style={{marginTop:'10px'}}>
                        <Loader color="yellow" size={"md"} />
                   </Center>}
                      </Box>
                    ) : (
                      <>
                        <Box className={classes.inputs}>
                          {paymentIntentData !== null ? (
                            <Elements
                              stripe={stripePromise}
                              options={{ clientSecret: paymentIntentData }}
                            >
                              <PaymentForm
                                paymentIntentClientSecret={paymentIntentData}
                                onPaymentSuccess={handlePaymentSuccess}
                                paymentoption={paymentoption}
                              />
                            </Elements>
                          ) : <Center style={{marginTop:'10px'}}>
                          <Loader color="yellow" size={"md"} />
                     </Center>}
                        </Box>
                      </>
                    )}
                  </>
                )}
                {paymentoption === "cash" || paymentoption === "cheque" ? (
                  <Button
                    size="lg"
                    type="submit"
                    color="yellow"
                    style={{ width: "100%" }}
                    loading={connectingCard}
                    className={classes.payBtn}
                  >
                    Pay Now
                  </Button>
                ) : null}
              </form>
            </Card>
          </Container>
        ) : (
          <Center>
            <Text>Your Invoice Is Paid already</Text>
          </Center>
        ))}
    </Box>
  );
};

export default InvoicePayment;
